import Vue from 'vue'
import router from './router'
import Home from 'pages/home/Home'
import store from './store'
import Organization from 'pages/home/components/Organization'
import Friendlinks from '@/common-components/Friendlinks'
import CommonFooter from '@/common-components/CommonFooter'
import QRCode from '@/common-components/QRCode'
import MiddleNav from 'pages/middleschool/Middlenav'
import MiddleCourse from 'pages/middleschool/Middlecourse'
import PrimarySchool from 'pages/primaryschool/PrimarySchool'
import English from 'pages/english/English.vue'
import Univercity from 'pages/univercity/Univercity'
import Gobroad from 'pages/gobroad/Gobroad'
import fastclick from 'fastclick'
import VueLazyLoad from 'vue-lazyload'
import VueCookies from 'vue-cookies'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import animate from 'animate.css'
import 'styles/reset.css'
import 'styles/border.css'
import 'swiper/dist/css/swiper.css'
import 'babel-polyfill'
import { homeFriendlinks } from './api/js/home/friendlinks.js'
import { middleFriendLinks } from './api/js/middleschool/friendlinks.js'
import { primaryFriendLinks } from './api/js/primary/friendlinks.js'
import { univercityFriendLinks } from './api/js/univercity/friendlinks.js'

// require styles
Vue.config.productionTip = false
fastclick.attach(document.body)

Vue.use(VueLazyLoad)
Vue.use(VueCookies)
Vue.use(animate)

Vue.use(VueAwesomeSwiper, {
  loop: true,
  autoplay: 5000,
  autoplayDisableOnInteraction: false
})

/* eslint-disable no-new */

//首页实例化
document.getElementById('container') && new Vue({
  el: '#container',
  router,
  store,
  components: { Home },
  template: '<Home/>'
})

document.getElementById('organization') && new Vue({
  el: '#organization',
  components: { Organization },
  template: '<Organization/>'
})

document.getElementById('friendlyLink') && new Vue({
  el: '#friendlyLink',
  data () {
    return {
      homeFriendlinks
    }
  },
  components: { Friendlinks },
  template: '<Friendlinks :data="homeFriendlinks"/>'
})

document.getElementById('footer') && new Vue({
  el: '#footer',
  components: { CommonFooter },
  template: '<CommonFooter/>'
})

document.getElementById('QRCode') && new Vue({
  el: '#QRCode',
  components: { QRCode },
  template: '<QRCode/>'
})

//中学实例化
document.getElementById('middle-nav') && new Vue({
  el: '#middle-nav',
  store,
  components: { MiddleNav },
  template: '<MiddleNav/>'
})

document.getElementById('middle-floor') && new Vue({
  el: '#middle-floor',
  store,
  components: { MiddleCourse },
  template: '<MiddleCourse/>'
})

document.getElementById('middle-friendlylink') && new Vue({
  el: '#middle-friendlylink',
  data () {
    return {
      middleFriendLinks
    }
  },
  components: { Friendlinks },
  template: '<Friendlinks :data="middleFriendLinks"/>'
})

//小学实例化
document.getElementById('primaryschool') && new Vue({
  el: '#primaryschool',
  data () {
    return {}
  },
  store,
  components: { PrimarySchool },
  template: '<PrimarySchool />'
})

//大学实例化
document.getElementById('univercity') && new Vue({
  el: '#univercity',
  data () {
    return {
      univercityFriendLinks
    }
  },
  store,
  components: { Univercity },
  template: '<Univercity />'
})

document.getElementById('primary-friendlylink') && new Vue({
  el: '#primary-friendlylink',
  data () {
    return {
      primaryFriendLinks
    }
  },
  components: { Friendlinks },
  template: '<Friendlinks :data="primaryFriendLinks"/>'
})

//英语实例化
document.getElementById('english') && new Vue({
  el: '#english',
  data () {
    return {}
  },
  store,
  components: { English },
  template: '<English />'
})


//出国实例化
document.getElementById('gobroad') && new Vue({
  el: '#gobroad',
  data () {
    return {}
  },
  store,
  components: { Gobroad },
  template: '<Gobroad />'
})



// WEBPACK FOOTER //
// ./src/main.js